import "./VendorFilter.scss";
import { TfiAngleDown } from "react-icons/tfi";

const VendorFilter = ({ dd, setDd, dataList, filter, setFilter }) => {
  return (
    <section className="vendor_filter_dd">
      <div className="content_wrap py-5">
        <div
          className={`filter_dd_wrap ${dd ? "active" : ""}`}
          onClick={(e) => {
            e.stopPropagation();
            setDd((prev) => !prev);
          }}
        >
          <p>
            {filter
              ? dataList?.find((ele) => ele?._id === filter)?.category_name
              : "All"}
          </p>{" "}
          <TfiAngleDown />
          <div className={`option_wrap ${dd ? "active" : ""}`}>
            <button
              type="button"
              className={`${filter ? "" : "active"}`}
              onClick={() => setFilter("")}
            >
              All
            </button>
            {dataList?.map((item) => {
              return (
                <button
                  type="button"
                  className={`${filter === item?._id ? "active" : ""}`}
                  onClick={() => setFilter(item?._id)}
                  key={item?._id}
                >
                  {item?.category_name}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VendorFilter;
